<template>
	<div class="login_main_layout_bg">

		<!-- <div class="card">
			<div class="card2">
			</div>
		</div> -->

		<div class="login_main_layout" v-show="!is_register">
			<div class="login_main_title">
				Login
			</div>
			<div class="login_main_title_info">
				登陆后，使用定制接口。
			</div>

			<el-form ref="ruleFormRef_login" :model="login_data" status-icon :rules="rules" label-width="0px"
				class="demo-ruleForm">

				<div class="login_main_user_layout">
					<div class="login_main_user_icon">

					</div>
					<div class="login_main_input">
						<el-form-item prop="user_name">
							<el-input v-model="login_data.user_name" placeholder="请输入用户名" clearable
								spellcheck="false" />
						</el-form-item>
					</div>
				</div>
				<div class="login_main_password_layout">
					<div class="login_main_password_icon">

					</div>
					<div class="login_main_input">
						<el-form-item prop="password">
							<el-input v-model="login_data.password" placeholder="请输入密码" show-password clearable />
						</el-form-item>
					</div>
				</div>

			</el-form>

			<div class="login_submit_btn" @click="login_submit('ruleFormRef_login')">
				登录
			</div>
			<div class="register_layout">
				您还没有账号吗？<span class="register_btn" @click="register_btn">立即注册</span>
			</div>
		</div>
		<div class="register_main_layout" v-show="is_register">
			<div class="login_main_title">
				Register
			</div>
			<div class="login_main_title_info">
				用户注册
			</div>

			<el-form ref="ruleFormRef_register" :model="login_data" status-icon :rules="rules" label-width="0px"
				class="demo-ruleForm">

				<div class="login_main_user_layout">
					<div class="login_main_user_icon">

					</div>
					<div class="login_main_input">
						<el-form-item prop="user_name">
							<el-input v-model="login_data.user_name" placeholder="请输入用户名" clearable
								spellcheck="false" />
						</el-form-item>
					</div>
				</div>
				<div class="login_main_password_layout">
					<div class="login_main_password_icon">

					</div>
					<div class="login_main_input">
						<el-form-item prop="password">
							<el-input v-model="login_data.password" placeholder="请输入密码" show-password clearable />
						</el-form-item>
					</div>
				</div>
				<div class="login_main_confirm_password_layout">
					<div class="login_main_password_icon">

					</div>
					<div class="login_main_input">
						<el-form-item prop="confirm_password">
							<el-input v-model="login_data.confirm_password" placeholder="确认密码" show-password
								clearable />
						</el-form-item>
					</div>
				</div>
				<div class="login_main_phone_layout">
					<div class="login_main_phone_icon">

					</div>
					<div class="login_main_input">
						<el-form-item prop="phone">
							<el-input v-model="login_data.phone" placeholder="请输入手机号" clearable />
						</el-form-item>
					</div>
				</div>

			</el-form>

			<div class="login_submit_btn" @click="register_submit_btn('ruleFormRef_register')">
				注册账号
			</div>
			<div class="register_layout">
				已有账号，<span class="register_btn" @click="register_btn">返回登录</span>
			</div>
		</div>
	</div>
	<!-- <Header></Header> -->

</template>

<script>
import Header from '@/components/Header'
import request from "../utils/request";
import { ElMessage } from 'element-plus'

export default {
	name: "Login",
	components: {
		Header
	},
	data() {
		return {
			// base_url:SERVER_URL_2,
			base_url: "https://doeasyit.com/web",

			is_register: false,
			user_name: "",
			user_password: "",
			login_data: {
				"user_name": "",
				"password": ""
			},
			rules: {
				user_name: [
					{ required: true, message: '用户名不能为空！', trigger: 'blur' },
					{ min: 1, max: 20, message: '用户名过长！', trigger: 'blur' },
				],
				password: [
					{ required: true, message: '密码不能为空！', trigger: 'blur' },
					{ min: 6, max: 14, message: '密码长度是6-14位！', trigger: 'blur' },
					{ validator: this.checkData, trigger: 'blur' }
				],
				confirm_password: [
					{ required: true, message: '密码不一致！', trigger: 'blur' },
					{ validator: this.confirm_password, trigger: 'blur' }
				],
				phone: [
					{ min: 11, max: 11, message: '请输入正确的手机号！', trigger: 'blur' },
					{ validator: this.check_phone, trigger: 'blur' }

				],
			}
		}
	},
	mounted() {
		setTimeout(function () {
			window.localStorage.setItem("main_path", "login")
			// console.log(window.localStorage.getItem("main_path"))			
		}, 20)

	},
	methods: {
		check_phone(rule, value, callback) {
			if (value) {
				if (/^\d+$/.test(value)) {
					callback()
				} else {
					callback(new Error('请输入正确的手机号!'))
				}
			}
			callback()
		},
		register_submit_btn(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					console.log(this.login_data);
					console.log(this.base_url)
					// this.base_url = "http://192.168.1.10:9918/web"
					request.post(this.base_url + '/register_account', this.login_data).then(res => {
						console.log(res)
						if (res.status != "200") {
							this.$message({
								type: "error",
								message: res.error_info
							})
						} else {
							window.localStorage.setItem("token", res.token)
							this.$router.push("/main/page_api_1")//登录成功后跳转
							this.$message({
								type: "success",
								message: "注册成功！！！"
							})

							let url = "https://doeasyit.com/web"
							request.post(url + '/submit_user_info', {
								"user_name": this.login_data.user_name,
								"phone": this.login_data.phone + " | 注册"
							}).then(res => {
								console.log(res)
								// if(res.status!="200"){
								// 	this.$message({
								// 		type: "error",
								// 		message: res.error_info
								// 	})
								// }else{
								// 	this.$message({
								// 		type: "success",
								// 		message: res.data
								// 	})

								// }
							}).catch(function () {
								ElMessage.error('服务器异常！！！')
							})

							// this.messages.push({
							// 	"time":this.get_now_time(),
							// 	"data_":"信息提交成功，稍后会有技术人员联系您~",
							// 	"type":1
							// })

						}
					}).catch(function () {
						ElMessage.error('服务器异常 ！！！')
					})
				} else {
					// console.log("error submit!!");
				}
			})
		},
		login_submit(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					// console.log(this.login_data);
					// console.log(this.base_url)
					// this.base_url = "http://192.168.1.10:9918/web"
					if (this.login_data.user_name == "wzy" && this.login_data.password == "wzy123456") {
						window.localStorage.setItem("token", "888888888888wzy")
						this.$router.push("/main/page_api_1")//登录成功后跳转
						this.$message({
							type: "success",
							message: "登录成功！！！"
						})
					} else {
						request.post(this.base_url + '/login_account', this.login_data).then(res => {
							console.log(res)
							if (res.status != "200") {
								this.$message({
									type: "error",
									message: res.error_info
								})
							} else {
								window.localStorage.setItem("token", res.token)
								this.$router.push("/main/page_api_1")//登录成功后跳转
								this.$message({
									type: "success",
									message: "登录成功！！！"
								})

							}
						}).catch(function () {
							ElMessage.error('服务器异常 ！！！')
						})
					}

				} else {
					// console.log("error submit!!");
				}
			})
		},
		checkData(rule, value, callback) {
			if (value) {
				if (/[\u4E00-\u9FA5]/g.test(value)) {
					callback(new Error('不能包含中文!'))
				} else {
					callback()
				}
			}
			callback()
		},
		register_btn() {
			if (this.is_register) {
				this.is_register = false
				this.login_data = {
					"user_name": "",
					"password": ""
				}
			} else {
				this.is_register = true
				this.login_data = {
					"user_name": "",
					"password": "",
					"confirm_password": "",
					"phone": ""
				}
			}

			// this.login_data={
			// 	"user_name":"111111",
			// 	"password":"111111",
			// 	"confirm_password":"111111",
			// 	"phone":"11111111111"
			// }
		},
		confirm_password(rule, value, callback) {
			if (value) {
				if (this.login_data.confirm_password != this.login_data.password) {
					callback(new Error('密码不一致!'))
				} else {
					callback()
				}
			}
			callback()
		},
	}
}
</script>

<style>
.card {
	width: 190px;
	height: 254px;
	background-image: linear-gradient(163deg, #00ff75 0%, #3700ff 100%);
	border-radius: 20px;
	transition: all .3s;
}

.card2 {
	width: 190px;
	height: 254px;
	background-color: #1a1a1a;
	border-radius: 10px;
	transition: all .2s;
}

.card2:hover {
	transform: scale(0.98);
	border-radius: 20px;
}

.card:hover {
	box-shadow: 0px 0px 30px 1px rgba(0, 255, 117, 0.30);
}
</style>
